import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, SectionItem } from './elements';

type Props = {
  readonly points_text?: string;
  readonly activities_text?: string;
  readonly participation_text?: string;
  readonly tooltip_text?: string;
  sections: {
    [key: string]: {
      name: string;
      participantCount: number;
      expectedParticipantCount: number;
    };
  };
  sectionKey: string;
};

function ChStPrt10(props: Props): React.ReactElement {
  const {
    points_text,
    activities_text,
    participation_text,
    tooltip_text,
    sections,
    sectionKey,
  } = props;
  const sortedList = Object.keys(sections)
    .map(key => ({
      expectedParticipants: sections[key].expectedParticipantCount,
      isUserSection: sectionKey === key,
      participantCount: sections[key].participantCount,
      sectionName: sections[key].name,
      percentage: Number(
        (
          (sections[key].participantCount /
            sections[key].expectedParticipantCount) *
          100
        ).toFixed(0)
      ),
    }))
    .sort((sectionA, sectionB) => sectionB.percentage - sectionA.percentage);

  return (
    <Wrapper>
      {sortedList.map(section => (
        <SectionItem
          points_text={points_text}
          activities_text={activities_text}
          participation_text={participation_text}
          tooltip_text={tooltip_text}
          expectedParticipants={section.expectedParticipants}
          isUserSection={section.isUserSection}
          key={section.sectionName}
          participantCount={section.participantCount}
          sectionName={section.sectionName}
        />
      ))}
    </Wrapper>
  );
}

ChStPrt10.propTypes = {
  sectionKey: PropTypes.string,
  sections: PropTypes.object,
};

export default ChStPrt10;
